const filmSizes = {
  '-1': '[ Custom ]',
  35: '35mm',
  70: 'IMAX',
  // TODO: add more of these!
};

const viewType = {
  values: [0, 1],
  labels: ['Field of View', 'Focal Length'],
};

const Camera = {
  schema: {
    targeted: { label: 'Enable Look Target', type: 'Boolean', defaultValue: false },
    focalDepthEnabled: { label: 'Use Focal Depth', type: 'Boolean', defaultValue: false },
    focalDepth: { label: 'Focal Depth', type: 'Number', defaultValue: 100, minValue: 0.001, animatable: true, hidden: true },

    axisDirection: { type: 'Object', hidden: true },
    zoomAxis: { type: 'Object', hidden: true },
    //size: { type: 'Object', hidden: true},  // Call getSize() to access this field, and call viewport.getViewRect(() for view resolution

    projection: { label: 'Projection', type: 'Options', defaultValue: 'Perspective', values: ['Perspective', 'Orthographic'] },

    viewCtrl: { type: 'Options', defaultValue: 0, values: viewType.values, labels: viewType.labels, label: 'View Control' },
    fieldOfView: { label: 'Field of View', type: 'Number', defaultValue: 45, minValue: 5, maxValue: 179, animatable: true },
    focalLength: { label: 'Focal Length (mm)', type: 'Number', defaultValue: 40, minValue: 1, maxValue: 400, step: 1, animatable: true },
    filmSizeBox: { type: 'Options', defaultValue: '35', values: Object.keys(filmSizes), labels: filmSizes, label: 'Film Size' },
    customFilmSize: { label: 'Custom Film Size (mm)', type: 'Number', defaultValue: 35, step: 0.1, minValue: 1, maxValue: 1000 },
    fStop: { label: 'F-Stop', type: 'Number', defaultValue: 2.8, minValue: 0.7, maxValue: 32, step: 0.1 },
    filmOffset: { label: 'Film Offset (mm)', type: 'Vec2', defaultValue: { x: 0, y: 0 }, minValue: -1000.0, step: 1.0, maxValue: 1000.0 },

    aspectRatio: { label: 'Aspect Ratio', type: 'Number', defaultValue: 16.0 / 9.0, step: 0.01, minValue: 0.01, maxValue: 10 },
    nearClip: { label: 'Near Clip', type: 'Number', step: 0.01, defaultValue: 0.1, minValue: 0.01 },
    farClip: { label: 'Far Clip', type: 'Number', defaultValue: 50000, step: 1, minValue: 0.00001, maxValue: 1000000 },
    orthoZoom: { label: 'Ortho Zoom', type: 'Number', defaultValue: 1, minValue: 0.01, step: 0.1 },


    // Orbit around
    targetDistance: { label: 'Distance to Target', type: 'Number', defaultValue: 5.0, minValue: 0.01 }, // Distance to target, in world space
    target: { label: 'Virtual Target', type: 'Vec3', defaultValue: { x: 0, y: 0, z: 0 }, hidden: true },  // Virtual target, in world space

    // Display
    showFrustum: { label: 'Show Frustum', type: 'Boolean', defaultValue: false },
    frustumColor: { label: 'Frustum Color', type: 'Color', defaultValue: { r: 1, g: 0.78, b: 0 }, animatable: true },
    showClipping: { label: 'Show Clipping', type: 'Boolean', defaultValue: false },
    showTarget: { label: 'Show Virtual Target', type: 'Boolean', defaultValue: false },
  },

  update: function (operator, primitive, { previousResult }) {
    //console.log('Camera update?', operator.aspectRatio, operator.fieldOfView, primitive, previousResult);
    Object.assign(primitive, operator);

    // Values initialized / editor from the translator that we carry through
    var keepKeys = ['pivotMatrix', 'upPosition', 'radiusConstraint', 'newRadiusConstraint', 'offset'];
    if (previousResult) {
      for (let i = 0; i < keepKeys.length; i++) {
        if (previousResult[keepKeys[i]]) primitive[keepKeys[i]] = previousResult[keepKeys[i]];
      }
    }

    let box = operator.filmSizeBox;
    primitive.filmSize = box === -1 ? operator.customFilmSize : parseFloat(box);
  },
};

export default { Camera };



// WEBPACK FOOTER //
// ./src/operators/Camera.js